<template>
    <!-- NAV -->
    <nav class="main-nav">
      
      <a href="/Home" aria-label="Home">
        <img
        src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/nav-text.png"
        alt="Cocoa Loops × Wonka" class="nav-logo-text" />
      </a>

      <ul class="nav-links">
        <li><a href="/Home#hero">Home</a></li>
        <li><a href="/Home#grand-prize">Grand Prize</a></li>
        <li><a href="/Home#how-to-enter">How To Enter</a></li>
        <li><a href="/Home#product">The Cereal</a></li>
        <li><a href="/Home#secondary-prize">More Prizes</a></li>
        <li><a href="/Home#faq">FAQ</a></li>
      </ul>

      <router-link to="/upload" class="nav-cta">
        Upload Receipt
        <svg class="btn-icon" width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </router-link>

      <button class="nav-toggle" type="button" aria-label="Open menu" :aria-expanded="isMobileMenuOpen.toString()"
        aria-controls="mobile-menu" @click="toggleMobileMenu" :class="{ 'open': isMobileMenuOpen }">
        <span class="bars" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
    </nav>

    <!-- Mobile nav menu (≤900px) -->
    <div class="mobile-menu" id="mobile-menu" :class="{ 'open': isMobileMenuOpen }">
      <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/logo-lockup.png" alt="Kellogg's Cocoa Loops × Wonka" class="mobile-menu__logo" />
      <ul>
        <li><router-link to="/upload" @click="closeMenu">Enter Now</router-link></li>
        <li><a href="/Home#hero" @click="closeMenu">Home</a></li>
        <li><a href="/Home#grand-prize" @click="closeMenu">Grand Prize</a></li>
        <li><a href="/Home#how-to-enter" @click="closeMenu">How To Enter</a></li>
        <li><a href="/Home#product" @click="closeMenu">The Cereal</a></li>
        <li><a href="/Home#secondary-prize" @click="closeMenu">More Prizes</a></li>
        <li><a href="/Home#faq" @click="closeMenu">FAQ</a></li>
      </ul>
    </div>

    <!-- Curved-edge clip masks for the image-to-image scene transitions -->
    <svg width="0" height="0" style="position:absolute" aria-hidden="true">
      <defs>
      <!-- Previous even wave, mirrored left→right: dip on the left-center (~30%),
         rising toward the right. Amplitude kept as before — we'll tune it next.
         objectBoundingBox keeps the depth tied to each section's height. -->
      <clipPath id="waveA" clipPathUnits="objectBoundingBox">
        <path d="M0,0 L0,0.9205 C0.32,1.083 0.66,0.7675 1,0.953 L1,0 Z"></path>
      </clipPath>
      <!-- waveA's bottom curve remapped into the 15.5%-tall .scene-cap strip
         (y' = (y − 0.845) / 0.155) — used by the two tall resize-safe sections. -->
      <clipPath id="waveCap" clipPathUnits="objectBoundingBox">
        <path d="M0,0 L0,0.4871 C0.32,1.5355 0.66,-0.5 1,0.6968 L1,0 Z"></path>
      </clipPath>
    </defs>
    </svg>

  <banner></banner>
</template>


<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch, onMounted } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale, t } = useI18n();
    const currentLang = ref(locale.value);
    const isMobileMenuOpen = ref(false);

    const toggleMobileMenu = () => {
      isMobileMenuOpen.value = !isMobileMenuOpen.value;
    };

    const closeMenu = () => {
      isMobileMenuOpen.value = false;
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      await loadLocaleMessages(lang);
      locale.value = lang;
      localStorage.setItem('locale', lang);
      currentLang.value = lang;
      injectGTM();
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    onMounted(() => {
      injectGTM();
    });

    const injectGTM = () => {
      const gtmId = t('gtmId');
      if (!gtmId) return;

      document.querySelectorAll("[data-gtm]").forEach(el => el.remove());

      const script = document.createElement("script");
      script.setAttribute("data-gtm", gtmId);
      script.innerHTML = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
          var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
          j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${gtmId}');
      `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.setAttribute("data-gtm", gtmId);
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.prepend(noscript);
    };

    return { currentLang, changeLanguage, isMobileMenuOpen, toggleMobileMenu, closeMenu };
  },
};
</script>